import $ from 'jquery';
import intlTelInput from 'intl-tel-input/build/js/intlTelInputWithUtils';
import fr from "intl-tel-input/i18n/fr";

function init($input, extraOptions) {
    // Input has already been initialized
    if (intlTelInput.getInstance($input[0])) {
        return;
    }

    // Compute iti options
    const options = {
        i18n: fr,
        nationalMode: false,
        ...$input.data('options'),
        ...extraOptions ?? {},
    };

    // Insert hidden input that will contain phone number in E164 format.
    const $e164Input = $('<input>', {
        id: $input.attr('id') ? $input.attr('id') + '--e164' : undefined,
        type: 'text',
        class: [
            'iti__sys-vision-e164-input',
            ...['form-field-input', 'is-invalid'].filter(cls => $input.hasClass(cls)),
        ].join(' '),
        tabindex: -1,
        ...Object.fromEntries(
            ['form', 'name', 'value', 'disabled', 'aria-describedby', 'data-default', 'data-validate-related']
                .map(attr => [attr, $input.attr(attr)])
        ),
    })
        .insertAfter($input.closest('.input-group').addBack().first());

    // Remove some attributes from input that have been moved to e164 input
    for (const attr of ['form', 'name', 'value']) {
        $input.removeAttr(attr);
    }

    // Instantiate iti
    const iti = intlTelInput($input[0], options);
    const $itiContainer = $input.closest('.iti');

    function updateE164Input() {
        let number = iti.getNumber();

        number = number.replace(/[^\w+]+/g, '');
        if (number === '+' + iti.getSelectedCountryData().dialCode) {
            number = '';
        }

        $e164Input.val(number);
    }

    // Handle events on iti container
    $itiContainer.on('focusout', function (event) {
        // Ignore this event if the element that took the focus is a descendant of iti container
        if (event.relatedTarget && $.contains($itiContainer[0], event.relatedTarget)) {
            return;
        }

        iti.setNumber(iti.getNumber());
        updateE164Input();
        $e164Input.trigger('focusout').trigger('change');
    });

    // Handle input events
    $input.on({
        'input.sysVision countrychange.sysVision': function () {
            updateE164Input();
            $e164Input.trigger('input').trigger('keyup');
        },
    });

    // Handle events on E164 hidden input (may be triggered by external code).
    $e164Input.on({
        'focus.sysVision': function () {
            $input.trigger('focus');
        },
        'change.sysVision': function () {
            iti.setNumber($e164Input.val());
            updateE164Input();
        },
        'changeDisabled.sysVision': function (event, disabled) {
            $input.prop('disabled', disabled);
        },
        'changeValidationState.sysVision': function (event, toggledStates) {
            for (const state in toggledStates) {
                $input.toggleClass('is-' + state, toggledStates[state]);
            }
        },
    });

    // Set initial value
    iti.setNumber($e164Input.val());
    updateE164Input();
}

$.fn.telInput = function (options) {
    this.each(function () {
        init($(this), options);
    });
};

// Initialize when DOM is ready
$(function () {
    $('input[type=tel]').telInput();
});
